import { render, staticRenderFns } from "./AboutTenbo.vue?vue&type=template&id=753231c5&scoped=true&"
import script from "./AboutTenbo.vue?vue&type=script&lang=js&"
export * from "./AboutTenbo.vue?vue&type=script&lang=js&"
import style0 from "./AboutTenbo.vue?vue&type=style&index=0&id=753231c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753231c5",
  null
  
)

export default component.exports